// export const API_ENDPOINT = 'https://erp-backend.mistermobile.sg/api';  // live
// export const API_ENDPOINT = 'http://127.0.0.1:8000/api'; // dev
export const API_ENDPOINT = 'https://stageerp-backend.mistermobile.sg/api';  // live
// export const API_ENDPOINT = 'https://deverp-backend.mistermobile.sg/api';  // dev
